import { render, staticRenderFns } from "./test2-1.vue?vue&type=template&id=54f3ffce&scoped=true&"
import script from "./test2-1.vue?vue&type=script&lang=js&"
export * from "./test2-1.vue?vue&type=script&lang=js&"
import style0 from "./test2-1.vue?vue&type=style&index=0&id=54f3ffce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3ffce",
  null
  
)

export default component.exports